import Intercom, { showNewMessage, shutdown, update } from '@intercom/messenger-js-sdk'
import { useEffect } from 'react'
import { useIntercomData } from 'src/modules/user/hooks/use-intercom-data'

export interface IntercomChatProps {
  show?: boolean
  startChat?: boolean
}

const INTERCOM_APP_ID = 'mmo1yzwl'

function bootIntercom() {
  Intercom({ app_id: INTERCOM_APP_ID })
}

bootIntercom()

export function IntercomChat({ show = true, ...rest }: IntercomChatProps) {
  useEffect(() => {
    if (show) {
      bootIntercom()
    } else {
      shutdown()
    }
  }, [show])

  if (!show) {
    return null
  }

  if (location.pathname.includes('onboarding/login')) {
    return <IntercomChatAnonymous {...rest} />
  }
  return <IntercomChatAuthenticated {...rest} />
}

function IntercomChatAnonymous({ startChat }: IntercomChatProps) {
  shutdown()
  update({
    user_id: null,
    name: null,
    email: null,
    intercom_user_jwt: null,
  })
  if (startChat) {
    showNewMessage('')
  }
  return null
}

function IntercomChatAuthenticated({ startChat }: IntercomChatProps) {
  const intercomData = useIntercomData()

  useEffect(() => {
    if (intercomData.data?.intercom_user_jwt) {
      update({
        intercom_user_jwt: intercomData.data.intercom_user_jwt,
      })
    }
    if (startChat) {
      showNewMessage('')
    }
  }, [intercomData.data, startChat])

  return null
}
